(() => {
  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const lockBody = (locked) => document.body.classList.toggle('overflow-hidden', locked);

  function initHeader() {
    const header = qs('[data-elevate-header]');
    const overlay = qs('[data-ew-overlay]');
    const menu = qs('[data-ew-mobile-menu]');
    const search = qs('[data-ew-search]');
    if (!header || header.dataset.ewReady === 'true') return;
    header.dataset.ewReady = 'true';
    const closeDropdowns = () => qsa('[data-ew-dropdown].is-open', header).forEach((item) => { item.classList.remove('is-open'); qs('.ew-nav-trigger', item)?.setAttribute('aria-expanded', 'false'); });
    qsa('[data-ew-dropdown]', header).forEach((item) => {
      const trigger = qs('.ew-nav-trigger', item); const panel = qs('[data-ew-panel]', item); if (!trigger || !panel) return;
      trigger.addEventListener('click', (event) => { event.stopPropagation(); const opening = !item.classList.contains('is-open'); closeDropdowns(); if (opening) { item.classList.add('is-open'); trigger.setAttribute('aria-expanded','true'); if (panel.classList.contains('ew-mega-menu')) panel.style.top = `${header.getBoundingClientRect().bottom}px`; } });
    });
    document.addEventListener('click', (event) => { if (!event.target.closest('[data-ew-dropdown]')) closeDropdowns(); });
    const showOverlay = () => { if (overlay) overlay.hidden = false; lockBody(true); };
    const hideOverlay = () => { if (overlay && !menu?.classList.contains('is-open') && !search?.classList.contains('is-open')) overlay.hidden = true; if (!menu?.classList.contains('is-open') && !search?.classList.contains('is-open')) lockBody(false); };
    const closeMenu = () => { if (!menu) return; menu.classList.remove('is-open'); menu.setAttribute('aria-hidden','true'); hideOverlay(); };
    const closeSearch = () => { if (!search) return; search.classList.remove('is-open'); search.setAttribute('aria-hidden','true'); hideOverlay(); };
    qs('[data-ew-open-menu]', header)?.addEventListener('click', () => { closeSearch(); menu?.classList.add('is-open'); menu?.setAttribute('aria-hidden','false'); showOverlay(); });
    qs('[data-ew-close-menu]')?.addEventListener('click', closeMenu);
    qsa('.ew-mobile-drawer a').forEach((link) => link.addEventListener('click', closeMenu));
    qs('[data-ew-open-search]', header)?.addEventListener('click', () => { closeMenu(); search?.classList.add('is-open'); search?.setAttribute('aria-hidden','false'); showOverlay(); setTimeout(() => qs('input[type="search"]', search)?.focus(),100); });
    qs('[data-ew-close-search]')?.addEventListener('click', closeSearch);
    overlay?.addEventListener('click', () => { closeMenu(); closeSearch(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') { closeDropdowns(); closeMenu(); closeSearch(); } });
  }

  function initHero(hero) {
    if (!hero || hero.dataset.ewReady === 'true') return; hero.dataset.ewReady='true';
    const slides=qsa('[data-ew-slide]',hero); const dots=qsa('[data-ew-hero-dot]',hero); const pause=qs('[data-ew-hero-pause]',hero); if (!slides.length) return;
    let index=0, paused=false, timer; const speed=Number(hero.dataset.heroSpeed || 7000);
    const show=(next)=>{index=(next+slides.length)%slides.length;slides.forEach((slide,i)=>slide.classList.toggle('is-active',i===index));dots.forEach((dot,i)=>dot.classList.toggle('is-active',i===index));};
    const restart=()=>{clearInterval(timer);if(!paused&&slides.length>1)timer=setInterval(()=>show(index+1),speed);};
    qs('[data-ew-hero-prev]',hero)?.addEventListener('click',()=>{show(index-1);restart();}); qs('[data-ew-hero-next]',hero)?.addEventListener('click',()=>{show(index+1);restart();});
    dots.forEach((dot)=>dot.addEventListener('click',()=>{show(Number(dot.dataset.ewHeroDot));restart();}));
    pause?.addEventListener('click',()=>{paused=!paused;pause.textContent=paused?'Play':'Pause';restart();}); restart();
  }

  function dataFromGoal(button) {
    return { key: button.dataset.key, title: button.dataset.resultTitle || button.textContent.trim(), copy: button.dataset.resultCopy || '', products: (button.dataset.resultProducts || '').split('|').filter(Boolean), url: button.dataset.resultUrl || '#journeys' };
  }

  function node(tag, text, className) {
    const element = document.createElement(tag);
    if (text !== undefined) element.textContent = text;
    if (className) element.className = className;
    return element;
  }

  function renderRitual(root, button) {
    const result = qs('[data-ew-ritual-result]', root);
    if (!result || !button) return;
    const data = dataFromGoal(button);
    const pills = node('div', undefined, 'ew-ritual-pills');
    data.products.forEach(name => pills.append(node('span', name, 'ew-ritual-pill')));
    const link = node('a', root.dataset.resultLabel || 'Explore This Ritual', 'ew-btn');
    link.href = data.url;
    result.replaceChildren(node('h3', data.title), node('p', data.copy), pills, link);
    qsa('[data-ew-ritual-option]', root).forEach(other => {
      other.classList.toggle('is-active', other === button);
      other.setAttribute('aria-pressed', String(other === button));
    });
  }

  function initRitual(root) {
    if (!root || root.dataset.ewReady === 'true') return;
    const buttons = qsa('[data-ew-ritual-option]', root);
    if (!buttons.length) return;
    root.dataset.ewReady = 'true';
    buttons.forEach(button => button.addEventListener('click', () => renderRitual(root, button)));
    renderRitual(root, qs('[data-ew-ritual-option].is-active', root) || buttons[0]);
    const shell = root.closest('.shopify-section') || root.parentElement;
    initQuiz(root, qs('[data-ew-quiz-modal]', shell));
  }

  function initQuiz(root, modal) {
    if (!modal || modal.dataset.ewReady === 'true') return;
    const stage = qs('[data-ew-quiz-stage]', modal);
    const result = qs('[data-ew-quiz-result]', modal);
    const progress = qs('[data-ew-quiz-progress]', modal);
    const configEl = qs('[data-ew-quiz-config]', modal);
    const trigger = qs('[data-ew-open-quiz]', root);
    if (!stage || !result || !configEl || !trigger) return;
    let config;
    try { config = JSON.parse(configEl.textContent); } catch { return; }
    modal.dataset.ewReady = 'true';
    const showResult = button => {
      const rec = dataFromGoal(button);
      stage.hidden = true;
      result.hidden = false;
      const title = qs('[data-ew-quiz-title]', result);
      title.textContent = rec.title;
      title.tabIndex = -1;
      qs('[data-ew-quiz-copy]', result).textContent = rec.copy;
      qs('[data-ew-quiz-products]', result).replaceChildren(...rec.products.map(name => node('span', name)));
      qs('[data-ew-quiz-link]', result).href = rec.url;
      if (progress) progress.style.width = '100%';
      title.focus();
    };
    const open = () => {
      stage.hidden = false;
      result.hidden = true;
      const question = node('div', undefined, 'ew-quiz-question');
      const options = node('div', undefined, 'ew-quiz-options');
      question.append(node('h3', config.question));
      qsa('[data-ew-ritual-option]', root).forEach(goal => {
        const button = node('button');
        button.type = 'button';
        button.append(node('strong', qs('strong', goal)?.textContent || ''), node('span', qs('span', goal)?.textContent || ''));
        button.addEventListener('click', () => showResult(goal));
        options.append(button);
      });
      question.append(options);
      stage.replaceChildren(question);
      if (progress) progress.style.width = '0%';
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      lockBody(true);
      qs('[data-ew-close-quiz]', modal)?.focus();
    };
    const close = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      lockBody(false);
      trigger.focus();
    };
    trigger.addEventListener('click', open);
    qs('[data-ew-close-quiz]', modal)?.addEventListener('click', close);
    modal.addEventListener('click', event => { if (event.target === modal) close(); });
    modal.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key !== 'Tab') return;
      const focusable = qsa('button, a[href], input, [tabindex="0"]', modal).filter(element => !element.disabled && element.getClientRects().length);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
  }


  function boot(){initHeader();qsa('[data-ew-hero]').forEach(initHero);qsa('[data-ew-ritual]').forEach(initRitual);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
